// Utility functions for JWT token handling

export const decodeToken = (token) => {
  try {
    if (!token) return null;
    
    // JWT tokens have 3 parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    // Decode the payload (second part)
    const payload = JSON.parse(atob(parts[1]));
    return payload;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const isTokenExpired = (token) => {
  try {
    const decoded = decodeToken(token);
    if (!decoded) return true;
    
    // Check if token is expired (exp is in seconds, Date.now() is in milliseconds)
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return true;
  }
};

export const isTokenExpiringSoon = (token, minutes = 5) => {
  try {
    const decoded = decodeToken(token);
    if (!decoded) return true;
    
    // Check if token will expire within the specified minutes
    const currentTime = Date.now() / 1000;
    const expirationTime = decoded.exp;
    const timeUntilExpiration = expirationTime - currentTime;
    const minutesUntilExpiration = timeUntilExpiration / 60;
    
    return minutesUntilExpiration <= minutes;
  } catch (error) {
    console.error('Error checking if token expires soon:', error);
    return true;
  }
};

export const getTokenExpirationTime = (token) => {
  try {
    const decoded = decodeToken(token);
    if (!decoded) return null;
    
    return new Date(decoded.exp * 1000); // Convert seconds to milliseconds
  } catch (error) {
    console.error('Error getting token expiration time:', error);
    return null;
  }
};

export const getTimeUntilExpiration = (token) => {
  try {
    const decoded = decodeToken(token);
    if (!decoded) return 0;
    
    const currentTime = Date.now() / 1000;
    const expirationTime = decoded.exp;
    
    return Math.max(0, expirationTime - currentTime);
  } catch (error) {
    console.error('Error getting time until expiration:', error);
    return 0;
  }
}; 